<app-matrix-card
  title="{{ 'cards.matrixTracker' | translate }}"
  [periodLabel]="data()?.periodLabel || 'Last 180 Days'"
  iconUrl="/icons/tracker.png"
  link="/variance-tracker"
  [highlighted]="highlighted"
  aria-label="Matrix Tracker"
>
  @if (data(); as d) {
    <div class="flex items-center justify-center gap-[39px] mt-[50px]">
      <!-- Chart on the left -->
      <div class="shrink-0 size-[253px] drop-shadow-[0_4px_12px_rgba(0,0,0,0.4)]">
        <app-generic-chart [config]="d.chartConfig" [loading]="loading()" [minHeightPx]="250" />
      </div>

      <!-- Stats and legend on the right -->
      <div class="flex flex-col gap-[30px] items-start justify-end">
        <!-- Statistics -->
        <div class="flex flex-col gap-1 items-start justify-center leading-none text-white">
          <p class="font-black">
            <span class="text-[30px]">100</span>
            <span class="text-[17.5px]"> / {{ d.totalVariances }} (5%)</span>
          </p>
          <p class="text-[16px] font-normal uppercase tracking-[1.6px]">
            # of Variances
          </p>
        </div>

        <!-- Legend -->
        <div class="flex flex-col gap-[16px] items-start justify-center">
          <div class="flex gap-[8px] items-center">
            <div class="shrink-0 size-[18px]">
              <div class="size-full rounded-full bg-[#84cc16]"></div>
            </div>
            <p class="text-[18px] font-normal leading-[22px] text-white">
              {{ 'matrixTracker.reviewed' | translate }}
            </p>
          </div>
          <div class="flex gap-[8px] items-center">
            <div class="shrink-0 size-[18px]">
              <div class="size-full rounded-full bg-[#f59e0b]"></div>
            </div>
            <p class="text-[18px] font-normal leading-[22px] text-white">
              {{ 'matrixTracker.outstanding' | translate }}
            </p>
          </div>
          <div class="flex gap-[8px] items-center">
            <div class="shrink-0 size-[18px]">
              <div class="size-full rounded-full bg-[#88d3ee]"></div>
            </div>
            <div class="text-[18px] font-normal leading-[22px] text-white">
              <p>{{ 'matrixTracker.sendToInvestigation' | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  } @else if (error()) {
    <div class="absolute inset-0 -mx-5 -my-5 min-h-[200px] flex items-center justify-center">
      <p class="text-sm text-slate-400">{{ 'cards.loadError' | translate }}</p>
    </div>
  } @else {
    <div class="absolute inset-0 -mx-5 -my-5 min-h-[200px]">
      <app-loading [showLogo]="false" [textValue]="'cards.loading'"></app-loading>
    </div>
  }
</app-matrix-card>


